// loader-interceptor.service.ts
import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {LoaderService} from "../../providers/loader.service";
import { finalize } from 'rxjs/operators';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const shouldShowLoader = req.context.get(SHOW_LOADER);

    if (!shouldShowLoader) {
      return next.handle(req);
    }

    this.loaderService.requestStarted();

    return next.handle(req).pipe(
      finalize(() => this.loaderService.requestFinished())
    );
  }
}
